module.exports = __webpack_public_path__ + "static/media/rpcirkus.b9384382.png";